import { render, staticRenderFns } from "./Static.vue?vue&type=template&id=6d5db383&scoped=true&"
import script from "./Static.vue?vue&type=script&lang=js&"
export * from "./Static.vue?vue&type=script&lang=js&"
import style0 from "./Static.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Static.vue?vue&type=style&index=1&id=6d5db383&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5db383",
  null
  
)

export default component.exports